/**
 * @generated by `astryx theme` — do not edit manually.
 * @astryx-theme-record {"themes":{"neutral":"@astryxdesign/theme-neutral"},"defaultThemeSlug":"neutral"}
 */

import {neutralTheme as _astryxTheme0} from "@astryxdesign/theme-neutral/built";
import "@astryxdesign/theme-neutral/theme.css";
import "@astryxdesign/theme-neutral/fonts.css";

export const themes = {
  "neutral": _astryxTheme0,
} as const;
export type ThemeSlug = keyof typeof themes;

export const defaultThemeSlug: keyof typeof themes = "neutral";
